import { Pagination, Skeleton } from "@mui/material";
import {
  CalendarIcon,
  Cross2Icon,
  ReaderIcon,
  TrashIcon,
  UploadIcon,
  ZoomInIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { NavLink, useNavigate } from "react-router-dom";
import { HOME, checkTagValidity } from "../../Utils/Utils";
import { LIST_ELIGIBILITE, VERIFICATION_PAR_LOT } from "../../Utils/constant";
import model from "../../assets/model-fichier/liste_eligibilites.xlsx";
import { Tabs } from "../../components/Widget/Tab";
import { store } from "../../services/service";
import { useStoreApp } from "../../store/storeApp";
export const ListeEligibilité = () => {
  const [listVerification, setListVerification] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [active, setActive] = useState({
    index: 0,
    value: "Eligible en attente d'abonnement",
    statusEligible: "ELIGIBLE_EN_ATTENTE_ABONNEMENT",
    tag: "LISTE_EN_ATTENTE",
  });
  const [modeVerification, setModeVerification] = useState("");

  const [fichier, setFichier] = useState([]);

  const handleChangeFichier = (e) => {
    const selectedFiles = e.target.files;
    const newFiles = Array.from(selectedFiles);
    setFichier((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const listData = useStoreApp();
  const loading = listData.loading;
  const navigate = useNavigate();

  const listeTabsData = [
    {
      index: 0,
      value: "Eligible en attente d'abonnement",
      statusEligible: "ELIGIBLE_EN_ATTENTE_ABONNEMENT",
      tag: "LISTE_EN_ATTENTE",
    },
    {
      index: 1,
      value: "Eligible avec abonnement",
      statusEligible: "ELIGIBLE_EN_ABONNEMENT",
      tag: "LISTE_EN_ABONNEMENT",
    },
    {
      index: 2,
      value: "Pas eligible",
      statusEligible: "NON_ELIGIBLE",
      tag: "LISTE_PAS_ELIGIBLE",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    } else {
      setActive({
        index: 0,
        value: "Eligible en attente d'abonnement",
        statusEligible: "ELIGIBLE_EN_ATTENTE_ABONNEMENT",
        tag: "LISTE_EN_ATTENTE",
      });
    }
  }, []);

  useEffect(() => {
    if (active) {
      listData.getData(
        LIST_ELIGIBILITE,
        { page: 0, param: "", size: 9 },
        `&status=${active ? active.statusEligible : ""}&modeVerification=${modeVerification}`,
      );
    }
  }, [active, modeVerification]);

  const more = async (page) => {
    listData.getData(
      LIST_ELIGIBILITE,
      { page: page - 1, param: "", size: 9 },
      `&status=${active ? active.statusEligible : ""}`,
    );
  };

  return (
    <div className="">
      <div className="lg:flex items-center">
        <h3 class="font-mtn text-3xl font-bold">Liste des éligibilités</h3>
        <dialog id="modal_eligible" className="modal rounded-none">
          <div className="modal-box w-10/12 max-w-xl">
            <div className="modal-action">
              <h1 className="font-mtn mr-auto text-2xl font-bold">
                Verification par lot
              </h1>
              <form method="dialog">
                <button
                  id="close"
                  className="btn btn-sm btn-circle btn-ghost border-gray-200"
                >
                  <Cross2Icon />
                </button>
              </form>
            </div>
            <div>
              {submit !== null ? (
                <>
                  <label className="form-contro w-full">
                    <div className="label flex flex-col justify-start items-start gap-1.5">
                      <span className="label-text  font-medium text-gray-400"></span>
                      <div className="w-full">
                        {fichier.length !== 0 ? (
                          fichier.map((file, index) => (
                            <div
                              key={index}
                              className="rounded text-black border-dashed border  border-gray-400 px-3 my-2 w-full rounded-mdshadow-sm "
                            >
                              <div className="flex items-center">
                                <img
                                  src="https://static.vecteezy.com/system/resources/previews/017/396/828/non_2x/microsoft-excel-mobile-apps-logo-free-png.png"
                                  alt=""
                                  width={50}
                                  height={50}
                                />
                                <p>{file?.name}</p>
                                <button
                                  className="ml-auto w-fit bg-red-200 rounded"
                                  onClick={() => {
                                    setFichier([]);
                                  }}
                                >
                                  <TrashIcon />
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div
                            className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm "
                            onClick={() => {
                              document.getElementById("fichier").click();
                            }}
                          >
                            <div className="flex justify-center mb-3">
                              <UploadIcon />
                            </div>

                            <div>
                              <p className="font-mtn text-center text-sm mx-1">
                                Uploader le fichier à verifier. <br />
                                Fichier au format Xlsx
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </label>
                  <a
                    href={model}
                    download="model_liste_eligibilite"
                    className="btn text-white bg-black btn-sm mx-1"
                  >
                    Telecharger le model
                  </a>
                  <button
                    disabled={
                      submit ? true : fichier.length === 0 ? true : false
                    }
                    className="font-mtn bg-main btn btn-sm"
                    onClick={() => {
                      setSubmit(true);
                      store(VERIFICATION_PAR_LOT, "multipart/form-data", {
                        liste: fichier[0],
                      })
                        .then((res) => {
                          if (res.status === 200) {
                            setListVerification(res.data.donnee);
                            setSubmit(null);
                            listData.getData(
                              LIST_ELIGIBILITE,
                              { page: 0, param: "", size: 10 },
                              `&status=${active.statusEligible}`,
                            );
                            toast.success("Verification terminer");
                          }
                        })
                        .catch((err) => {
                          setSubmit(false);
                          toast.error(err?.response?.data?.donnee);
                        });
                    }}
                  >
                    Verifier
                  </button>
                </>
              ) : (
                <div className="my-8">
                  <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-1 my-4">
                    {listVerification.map((eligible) => (
                      <div
                        className={`border ${
                          eligible?.fttheligible !== "eligible"
                            ? "border-red-600"
                            : "border-green-600"
                        } px-3 py-2 rounded mb-3`}
                      >
                        <div className="flex gap-2">
                          <p className="text-xs font-semibold ">Status: </p>
                          <p
                            className={`text-xs font-bold ${
                              eligible?.fttheligible !== "eligible"
                                ? "text-red-600"
                                : "text-green-600"
                            }`}
                          >
                            {eligible?.fttheligible}{" "}
                          </p>
                        </div>

                        <div className="flex items-center gap-2">
                          <p className="text-sm font-semibold">
                            Numero de ticket:{" "}
                          </p>
                          <p
                            className={`text-sm ${
                              eligible?.fttheligible !== "eligible"
                                ? "text-red-600"
                                : "text-green-600"
                            }`}
                          >
                            {eligible?.numeroTicket}{" "}
                          </p>
                        </div>

                        <div className="flex items-center gap-2">
                          <p className="text-sm font-semibold">Telephone : </p>
                          <p className={`text-sm `}>{eligible?.numero} </p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="space-y-2 text-center my-8">
                    <p className="text-center text-sm">
                      Verification terminer,
                      <br /> vous pouvez consulter la liste des éligibilités
                    </p>
                    <button
                      className="mx-auto font-mtn bg-main btn btn-sm"
                      onClick={() => {
                        // document.getElementById('close').click()
                        setSubmit(false);
                        setFichier([]);
                      }}
                    >
                      Faire une autre verification
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </dialog>
        <div className="ml-auto flex items-center gap-2">
          {checkTagValidity("VERIFICATION_LOT") ? (
            <button
              onClick={() => {
                document.getElementById("modal_eligible").showModal();
              }}
              className="btn btn-sm h-10 hover:bg-[#000] bg-[#000] text-white"
            >
              Verification par lot
            </button>
          ) : null}
          {checkTagValidity("FAIRE_VERIFICATION") ? (
            <button
              onClick={() => {
                navigate(HOME + "/abonnements/enregistrement-intention");
              }}
              className="btn btn-sm h-10 hover:bg-[#ffcb05] bg-[#ffcb05] "
            >
              Faire une Verification
            </button>
          ) : null}
        </div>
      </div>

      <div className="mt-12 bg-white rounded-lg p-3 border border-[#f2f5fa]">
        <div className="lg:flex gap-2 items-center">
          <input
            onChange={(e) => {
              listData.getData(
                LIST_ELIGIBILITE,
                { page: 0, param: e.target.value, size: 10 },
                "&status=",
              );
            }}
            type="text"
            placeholder="Recherche..."
            className="text-[13px] input input-bordered px-3 my-2 w-80 h-9 text-gray-900 placeholder:text-gray-400"
          />
        </div>
        {filteredTabsData.length !== 0 ? (
          <Tabs
            tabsData={filteredTabsData}
            active={active}
            setActive={setActive}
          />
        ) : null}

        {active ? (
          <>
            <select
              onChange={(e) => setModeVerification(e.target.value)}
              className="select select-bordered max-w-xs text-xs my-2"
            >
              <option value="">Tout afficher</option>
              <option value="DIRECT">Direct</option>
              <option value="QRCODE">Qrcode</option>
              <option value="yello_pme">Yello PME</option>
            </select>
            <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 my-4">
              {listData?.data?.data?.length === 0
                ? "Aucune donnée"
                : listData?.data?.data?.length !== 0 && !listData?.loading
                  ? listData?.data?.data?.map((item) => (
                      <div
                        key={item?.id}
                        className="bg-white rounded-xl border-slate-200 border px-3 py-2 shadow-sm space-y-2"
                      >
                        <div className="mb-4 flex gap-2 items-center">
                          <p className="text-xs">
                            Ticket N°{item?.numeroTicket}
                          </p>
                          <p className="ml-auto text-xs flex gap-1 items-center font-medium">
                            <CalendarIcon />
                            {item?.dateCreation
                              ? new Date(item?.dateCreation).toLocaleString()
                              : "--"}
                          </p>
                        </div>

                        <div className="my-1 flex items-center">
                          <div className="flex items-center gap-2">
                            <div
                              className={`px-3 border rounded-full py-1 text-xs ${
                                item?.status ===
                                "ELIGIBLE_EN_ATTENTE_ABONNEMENT"
                                  ? "text-orange-700 border-orange-600 "
                                  : item?.status === "ELIGIBLE_EN_ABONNEMENT"
                                    ? "text-green-600 border-green-600 "
                                    : "text-red-600 border-red-600"
                              }  `}
                            >
                              {item?.status?.toLowerCase().replace(/_/g, " ")}
                            </div>
                          </div>
                        </div>

                        <div className="items-center gap-2 space-y-2">
                          <p className="text-xs flex gap-1">
                            Numero du client : <ReaderIcon />
                            {item?.numeroClient}{" "}
                          </p>
                        </div>

                        <div className="flex flex-wrap items-center gap-2">
                          {item?.modeVerification && (
                            <div className="my-1 flex items-center gap-1 rounded-full py-1 px-3 w-fit bg-gray-100">
                              <ZoomInIcon />
                              <p className="text-xs flex gap-1">
                                {item?.modeVerification.replace(/_/g, " ")}
                              </p>
                            </div>
                          )}

                          {item?.agent && (
                            <div className="my-1 flex items-center gap-1 rounded-full py-1 px-3 w-fit bg-gray-100">
                              <p className="text-xs flex gap-1 font-semibold">
                                Agent: {item?.agent}
                              </p>
                            </div>
                          )}
                        </div>

                        <div className="mt-3 space-y-1 mb-2">
                          {checkTagValidity("FAIRE_DEMANDE") && (
                            <div className="flex gap-1">
                              {item?.status ===
                              "ELIGIBLE_EN_ATTENTE_ABONNEMENT" ? (
                                <NavLink
                                  to={`${HOME}/abonnements/poursuivre-intention/${item?.numeroTicket}/1`}
                                  className="border btn btn-sm text-xs w-full font-mtn font-medium bg-[#ffcb05] border-[#ffcb05] hover:bg-[#ffcb05] hover:border-[#ffcb05] text-black"
                                >
                                  Faire la demande
                                </NavLink>
                              ) : null}
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  : [1, 2, 3].map((index) => (
                      <div
                        key={index}
                        className="bg-white rounded-xl border-slate-200 border px-3 py-2 shadow-sm"
                      >
                        <div className="mb-4 flex gap-4 items-center">
                          <p className="text-xs">
                            <Skeleton width={65} />
                          </p>
                          <p className="ml-auto text-xs flex gap-1 items-center font-medium">
                            <Skeleton width={85} />
                          </p>
                        </div>
                        <div className="my-1 flex items-center">
                          <div className="flex items-center gap-2">
                            <div
                              className={`px-3 border rounded-full py-1 text-xs font-semibold`}
                            >
                              <Skeleton width={64} />
                            </div>
                          </div>
                        </div>
                        <div className="items-center gap-2 space-y-2">
                          <p className="text-xs flex gap-1">
                            <Skeleton width={70} />
                          </p>
                        </div>
                      </div>
                    ))}
            </div>
          </>
        ) : null}

        {
          <div className="my-3 flex justify-end">
            {active ? (
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={listData?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            ) : null}
          </div>
        }
      </div>

      <input
        type="file"
        accept=".xlsx"
        hidden
        id="fichier"
        onChange={handleChangeFichier}
      />
    </div>
  );
};
